import { useSelector } from 'react-redux'
import { selectors as coreSelectors } from 'mage-core'

export const useChatClient = (): any => {
  const createClient: any = useSelector(coreSelectors.createBackendClient)
  return createClient('support-chat')
}
